export function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Encryption',
      description: 'Your data is protected with AES-256 encryption, the same standard used by governments and security experts worldwide to ensure maximum privacy.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speeds',
      description: 'Enjoy seamless browsing, streaming, and downloading with our optimized VPN servers that deliver high-speed connections without compromising security.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our worldwide VPN server network. Connect to multiple locations and bypass geo-restrictions effortlessly.'
    },
    {
      icon: 'ri-eye-off-line',
      title: 'No-Logs Policy',
      description: 'We never track, collect, or share your online activities. Your browsing history remains completely private with our strict no-logs VPN policy.'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices with one VPN account. Compatible with Windows, Mac, iOS, Android, and more for comprehensive security coverage.'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: 'Our dedicated support team is always available to assist you with any questions or technical issues regarding your VPN service.'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose <strong>TRAMETAL VPN</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our <strong>VPN solution</strong> combines cutting-edge security technology with user-friendly features to provide the best online protection experience.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-6">
                <i className={`${feature.icon} text-3xl text-teal-600`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">
                <a href="#features" className="hover:text-teal-600 transition-colors">
                  {feature.title}
                </a>
              </h4>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}